import { Routes, Route, Outlet } from "react-router-dom";
import Perfil from "../pages/Perfil";
import PerfilContextProvider from "../context/PerfilContextProvider";

export default function PerfilRoutes() {
  return (
    <>
      <PerfilContextProvider>
        <Routes>
          <Route path="/" element={<Perfil />} />
        </Routes>
        <Outlet />
      </PerfilContextProvider>
    </>
  );
}
